/**
 * Zusätzliche Redaction-Regeln der Filament-Panels (on top of defaultRules des
 * Pakets): die Panels zeigen überall Kunden-E-Mail-Adressen, die Defaults
 * decken aber nur email=-Parameter ab — eine Adresse im Freitext einer
 * Exception (console.error: … for jane.doe@example.com) ginge sonst durch.
 * Strenger als Alloy, daher kein Paritäts-Thema.
 */
export const EXTRA_REDACTIONS = [/[\w.+-]+@[\w-]+(?:\.[\w-]+)*\.[a-z]{2,}\b/gi];
